var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyReceive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    opacity: 0.4,
    d: "M15.6738 5.20905H16.8072C16.6488 4.98405 16.4822 4.77572 16.3072 4.56738L15.6738 5.20905Z",
    fill: "#E8F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    opacity: 0.4,
    d: "M15.4327 3.68359C15.2243 3.50859 15.016 3.34193 14.791 3.18359V4.31693L15.4327 3.68359Z",
    fill: "#E8F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    opacity: 0.4,
    d: "M14.166 6.45866C14.0827 6.45866 14.0077 6.44199 13.9243 6.40866C13.7743 6.34199 13.6493 6.22532 13.5827 6.06699C13.5493 5.99199 13.5327 5.90866 13.5327 5.82532V2.49199C13.5327 2.48366 13.541 2.47532 13.541 2.45866C12.466 1.95866 11.266 1.66699 9.99935 1.66699C5.39935 1.66699 1.66602 5.40033 1.66602 10.0003C1.66602 14.6003 5.39935 18.3337 9.99935 18.3337C14.5993 18.3337 18.3327 14.6003 18.3327 10.0003C18.3327 8.73366 18.041 7.53366 17.5327 6.45032C17.5244 6.45032 17.516 6.45866 17.4993 6.45866H14.166Z",
    fill: "#E8F0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M16.3169 4.56686L18.7753 2.10853C19.0169 1.86686 19.0169 1.46686 18.7753 1.2252C18.5336 0.983529 18.1336 0.983529 17.8919 1.2252L15.4336 3.68353C15.7503 3.95853 16.0419 4.25853 16.3169 4.56686Z",
    fill: "#E8F0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M14.7924 2.5C14.7924 2.15833 14.5091 1.875 14.1674 1.875C13.8341 1.875 13.5674 2.14167 13.5508 2.46667C13.9841 2.675 14.4008 2.90833 14.7924 3.18333V2.5Z",
    fill: "#E8F0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M18.1252 5.83301C18.1252 5.49134 17.8419 5.20801 17.5002 5.20801H16.8086C17.0836 5.59967 17.3252 6.01634 17.5252 6.44967C17.8586 6.43301 18.1252 6.16634 18.1252 5.83301Z",
    fill: "#E8F0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M11.4577 9.85L10.6243 9.55833V7.70833H10.691C11.116 7.70833 11.4577 8.08333 11.4577 8.54167C11.4577 8.88333 11.741 9.16667 12.0827 9.16667C12.4243 9.16667 12.7077 8.88333 12.7077 8.54167C12.7077 7.39167 11.8077 6.45833 10.691 6.45833H10.6243V6.25C10.6243 5.90833 10.341 5.625 9.99935 5.625C9.65768 5.625 9.37435 5.90833 9.37435 6.25V6.45833H9.12436C8.11603 6.45833 7.29102 7.30833 7.29102 8.35833C7.29102 9.575 7.99935 9.96667 8.54102 10.1583L9.37435 10.45V12.3H9.30769C8.88269 12.3 8.54102 11.925 8.54102 11.4667C8.54102 11.125 8.25768 10.8417 7.91602 10.8417C7.57435 10.8417 7.29102 11.125 7.29102 11.4667C7.29102 12.6167 8.19103 13.55 9.30769 13.55H9.37435V13.7583C9.37435 14.1 9.65768 14.3833 9.99935 14.3833C10.341 14.3833 10.6243 14.1 10.6243 13.7583V13.55H10.8743C11.8827 13.55 12.7077 12.7 12.7077 11.65C12.7077 10.425 11.9993 10.0333 11.4577 9.85ZM8.94934 8.96667C8.66601 8.86667 8.54102 8.80833 8.54102 8.35C8.54102 7.99166 8.80769 7.7 9.12436 7.7H9.37435V9.10833L8.94934 8.96667ZM10.8743 12.2917H10.6243V10.8833L11.0494 11.0333C11.3327 11.1333 11.4577 11.1917 11.4577 11.65C11.4577 12 11.191 12.2917 10.8743 12.2917Z",
    fill: "#E8F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyReceive);
export default __webpack_public_path__ + "static/media/money-receive.a4fe700bd915db4612d376a751c9f48a.svg";
export { ForwardRef as ReactComponent };